module.exports = __webpack_public_path__ + "static/media/confirmRoute.f271ebc9.svg";